module.exports = __webpack_public_path__ + "mask.jpg?ff080a47443ce24b5c692f81bbda669c";